import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMakeupGlyph from './svgs/MakeupGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var makeupGlyph = (props => useIcon(SvgMakeupGlyph, SvgMakeupGlyph, props));

export { makeupGlyph as default };
